import { render, staticRenderFns } from "./privacy-policy.html?vue&type=template&id=758de5e0&scoped=true&"
import script from "./privacy-policy.js?vue&type=script&lang=js&"
export * from "./privacy-policy.js?vue&type=script&lang=js&"
import style0 from "./privacy-policy.scss?vue&type=style&index=0&id=758de5e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758de5e0",
  null
  
)

export default component.exports